<template>
  <div>
    <Head></Head>
    <div class="body w">
      <h2>トップページへ > マイページ > 物流の状態</h2>
      <h3>物流状態</h3>
      <div class="main">
        <el-steps :active="index" align-center>
          <el-step
            :title="status1.name"
            :description="status1.datetime"
          ></el-step>
          <el-step
            :title="status2.name"
            :description="status2.datetime"
          ></el-step>
          <el-step
            :title="status3.name"
            :description="status3.datetime"
          ></el-step>
          <el-step
            :title="status4.name"
            :description="status4.datetime"
          ></el-step>
        </el-steps>
        <div class="content" v-if="index != -1">
          <h4>物流の状況：</h4>
          <div class="wuliu">
            <p v-for="(item, index) in lists" :key="index">
              {{ item.datetime }}
              <span v-if="item.show">{{ item.name }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Head from "../../../../components/head/Head";
import Foot from "../../../../components/foot/Foot";
import { deliveryStatus } from "../../../../api/API/DomesticLogistics";
export default {
  data() {
    return {
      datas: {},
      index: -1,
      lists: [],
      status1: {},
      status2: {},
      status3: {},
      status4: {},
    };
  },
  components: {
    Head,
    Foot,
  },
  created() {
    this.deliveryStatus();
  },
  methods: {
    deliveryStatus() {
      let list = {
        order: this.$route.query.trade,
        baojia_id: this.$route.query.id,
      };
      deliveryStatus(list).then((res) => {
        this.status1 = res.data.status1;
        this.status2 = res.data.status2;
        this.status3 = res.data.status3;
        this.status4 = res.data.status4;
        for (let key in res.data) {
          this.lists.push(res.data[key]);
          if (res.data[key].show == true) {
            this.index = key.substr(6);
          }
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.body {
  h2 {
    margin: 20px;
    font-size: 25px;
  }
  h3 {
    height: 50px;
    line-height: 50px;
    text-indent: 2em;
    font-size: 25px;
    background: #eee;
    border: 1px solid #ccc;
  }
  .main {
    padding: 50px 80px;
    border: 1px solid #ccc;
    border-top: 0;
    .content {
      border: 1px solid #ccc;
      margin-top: 20px;
      padding: 10px 30px;
      background: #eee;
      h4 {
        font-size: 25px;
        line-height: 50px;
        border-bottom: 1px solid #ccc;
      }
      p {
        line-height: 80px;
        font-size: 20px;
        span {
          margin-left: 50px;
        }
      }
      .wu {
        text-align: center;
        font-size: 25px;
        padding: 30px 0;
      }
    }
  }
  margin-bottom: 50px;
}
// .step01,
// .step02,
// .step03,
// .step04 {
//   width: 35px;
//   height: 35px;
//   background-size: 100% 100%;
// }
// .step01 {
//   background-image: url("~@/assets/img/wuliu1_1.png");
// }
// .step02 {
//   background-image: url("~@/assets/img/wuliu2_1.png");
// }
// .step03 {
//   background-image: url("~@/assets/img/wuliu3_1.png");
// }
// .step04 {
//   background-image: url("~@/assets/img/wuliu4_1.png");
// }
// /deep/ .el-steps {
//   width: 80%;
//   .el-step.is-horizontal .el-step__line {
//     top: 50%;
//     left: 94px;
//     right: 48px;
//   }
//   .el-step__head.is-process {
//     border-color: #dedede;
//   }
//   .el-step__head.is-finish {
//     border-color: #285edf;
//   }
//   .el-step__title.is-process {
//     color: #dedede;
//   }
//   .el-step__title.is-finish {
//     color: #285edf;
//   }
//   .el-step__icon {
//     width: 56px;
//     height: 56px;
//     border: 0;
//   }
//   .is-finish .step02{
//     background-image: url("~@/assets/images2/1_bank.png");
//   }
//   .is-finish .step03{
//     background-image: url("~@/assets/images2/1_legal_person.png");
//   }
//   .is-finish .step04{
//     background-image: url("~@/assets/images2/user_user.png");
//   }
// }
</style>